module.exports = __webpack_public_path__ + "static/img/11areaA_07.a31e230.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/11areaA_07.png
// module id = 1000
// module chunks = 1